const headerLinks = [
  {
    key: "overview",
    link: "/2024",
    label: "Overview",
  },
  {
    key: "guestOfHonour",
    link: "/2024/guest-of-honour",
    label: "Guest of Honour",
  },
  {
    key: "keynote",
    link: "/2024/keynote",
    label: "Keynote Speaker",
  },
  {
    key: "thematicThreads",
    link: "/2024/thematic-threads",
    label: "Thematic Threads",
  },
  {
    key: "awards",
    link: "/2024/awards",
    label: "Awards",
  },
];

export default headerLinks;
